import { Controller, ActionEvent } from "@hotwired/stimulus";

export default class TabsController extends Controller {
  static targets = ["tab"];

  static values = {
    session: String,
  };

  declare tabTargets : HTMLLinkElement[];
  declare sessionValue: string;

  connect(): void {
    const tabStatusValue = this.sessionValue

    this.selectTab(tabStatusValue)
  }

  private selectTab(status: string) :void {
    if (status != 'live') {
      for (const el of this.tabTargets)
        el.classList.remove("is-active");

      this.tabTargets.map(tab => {
        if (tab.querySelector('span')?.innerHTML.toLowerCase() == status) {
          tab.classList.add('is-active')
        }
      })
    }
  }

  switch(ev: ActionEvent) : void {
    if (ev.currentTarget instanceof HTMLElement) {
      const tabIndex = ev.currentTarget.getAttribute("data-tab-index");

      for (const el of this.tabTargets)
        el.classList.remove("is-active");

      const finder = (el : HTMLElement) => el.getAttribute("data-tab-index") == tabIndex;

      const tabEl = this.tabTargets.find(finder);

      tabEl?.classList.add("is-active");
    }
  }
}
